export function observeTelegramViewport(app, root = document.documentElement) {
  const viewport = window.visualViewport;
  let baseline = Math.max(window.innerHeight, app.viewportStableHeight || 0), frame;
  const editable = element => element?.matches?.('input:not([type="button"]):not([type="submit"]), textarea, [contenteditable="true"]');
  const sync = () => {
    const nativeHeight = app.viewportHeight || app.viewportStableHeight || window.innerHeight;
    const visible = Math.min(viewport?.height || nativeHeight, nativeHeight);
    if (!editable(document.activeElement)) baseline = Math.max(window.innerHeight, nativeHeight);
    const keyboard = editable(document.activeElement) && baseline - visible > 120;
    root.dataset.keyboard = keyboard ? 'true' : 'false';
    root.style.setProperty('--polka-visible-height', `${visible}px`);
    root.style.setProperty('--polka-visible-top', `${viewport?.offsetTop || 0}px`);
    if (keyboard) {
      const rect = document.activeElement.getBoundingClientRect();
      if (rect.bottom > visible + (viewport?.offsetTop || 0) - 16 || rect.top < (app.safeAreaInset?.top || 0)) {
        document.activeElement.scrollIntoView({ block: 'nearest' });
      }
    }
  };
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); };
  for (const event of ['resize', 'scroll']) viewport?.addEventListener(event, schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('focusin', schedule); document.addEventListener('focusout', schedule);
  app.onEvent('viewportChanged', schedule);
  sync();
  return () => {
    cancelAnimationFrame(frame);
    for (const event of ['resize', 'scroll']) viewport?.removeEventListener(event, schedule);
    window.removeEventListener('resize', schedule);
    document.removeEventListener('focusin', schedule); document.removeEventListener('focusout', schedule);
    app.offEvent('viewportChanged', schedule);
    delete root.dataset.keyboard;
  };
}
